import "./index.css";

const LoaderComponent = () => {
    return <div className="loader__custom"></div>;
};

export default LoaderComponent;
